export const PAYMENT_METHOD_ID_PARAM_NAME = 'paymentMethodId';
export const PAYMENT_METHOD_ID_PARAM_TEMPLATE = `/:${PAYMENT_METHOD_ID_PARAM_NAME}?`;
